var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageInbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M1.5 16.5h6.13c.47 0 .85.34.98.8.35 1.27 1.51 2.2 2.89 2.2h3c1.38 0 2.54-.93 2.89-2.2.13-.46.5-.8.98-.8h6.13M5.5 13.5v-12h11.97l3.03 3.06v8.94M10 7h6M10 11h6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m23.5 7.5 1 9v6c0 1.1-.9 2-2 2h-19c-1.1 0-2-.9-2-2v-6l1-9"
})));
export default SvgMessageInbox;